import "./SectionFiveSlider.css";

import React from "react";

import { useState, useEffect, useRef } from "react";

import { SectionFiveSliderCard } from "./SectionFIveSliderCard";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

export const SectionFiveSlider = ({ sectionFiveSliderContent }) => {
  const sectionFiveButtonForward = useRef(null);
  const sectionFiveButtonBack = useRef(null);
  const sectionFiveSlider = useRef(null);
  let sectionFiveSliderCounter = 0;
  let sectionFiveTimer;

  useEffect(() => {
    if (sectionFiveSliderContent.length !== 0) {
      sectionFiveTimer = setInterval(() => {
        sectionFiveSliderCounter = sectionFiveSliderCounter - 1;
        sectionFiveButtonBack.current.style.opacity = "1";
        sectionFiveButtonBack.current.style.backgroundColor = "#c0aa83";
        sectionFiveButtonBack.current.style.pointerEvents = "all";
        let sectionFiveSliderTranslateIndex;
        if (window.innerWidth <= 540) {
          sectionFiveSliderTranslateIndex = sectionFiveSliderCounter * 20.3;
        } else if (window.innerWidth <= 750) {
          sectionFiveSliderTranslateIndex = sectionFiveSliderCounter * 30.3;
        } else if (window.innerWidth <= 1060) {
          sectionFiveSliderTranslateIndex = sectionFiveSliderCounter * 43.3;
        } else {
          sectionFiveSliderTranslateIndex = sectionFiveSliderCounter * 63.3;
        }
        if (sectionFiveSliderCounter === -sectionFiveSliderContent.length) {
          sectionFiveButtonBack.current.style.opacity = "0.5";
          sectionFiveButtonBack.current.style.backgroundColor = "white";
          sectionFiveButtonBack.current.style.pointerEvents = "none";
          sectionFiveButtonForward.current.style.opacity = "1";
          sectionFiveButtonForward.current.style.backgroundColor = "#c0aa83";
          sectionFiveButtonForward.current.style.pointerEvents = "all";
          sectionFiveSlider.current.style.transform = `translateX(0rem)`;
          sectionFiveSliderCounter = 0;
        } else {
          sectionFiveSlider.current.style.transform = `translateX(${sectionFiveSliderTranslateIndex}rem)`;
          if (
            sectionFiveSliderCounter ===
            -sectionFiveSliderContent.length + 1
          ) {
            sectionFiveButtonForward.current.style.opacity = "0.5";
            sectionFiveButtonForward.current.style.backgroundColor = "white";
            sectionFiveButtonForward.current.style.pointerEvents = "none";
          }
        }
      }, 7000);
    } else {
    }
    return () => {
      clearInterval(sectionFiveTimer);
    };
  }, [sectionFiveSliderContent]);
  const handleSectionFiveButtonForward = () => {
    clearInterval(sectionFiveTimer);
    sectionFiveSliderCounter = sectionFiveSliderCounter - 1;
    sectionFiveButtonBack.current.style.opacity = "1";
    sectionFiveButtonBack.current.style.backgroundColor = "#c0aa83";
    sectionFiveButtonBack.current.style.pointerEvents = "all";
    let sectionFiveSliderTranslateIndex;
    if (window.innerWidth <= 540) {
      sectionFiveSliderTranslateIndex = sectionFiveSliderCounter * 20.3;
    } else if (window.innerWidth <= 750) {
      sectionFiveSliderTranslateIndex = sectionFiveSliderCounter * 30.3;
    } else if (window.innerWidth <= 1060) {
      sectionFiveSliderTranslateIndex = sectionFiveSliderCounter * 43.3;
    } else {
      sectionFiveSliderTranslateIndex = sectionFiveSliderCounter * 63.3;
    }
    sectionFiveSlider.current.style.transform = `translateX(${sectionFiveSliderTranslateIndex}rem)`;
    if (sectionFiveSliderCounter === -sectionFiveSliderContent.length + 1) {
      sectionFiveButtonForward.current.style.opacity = "0.5";
      sectionFiveButtonForward.current.style.backgroundColor = "white";
      sectionFiveButtonForward.current.style.pointerEvents = "none";
    }
  };
  const handleSectionFiveButtonBack = () => {
    clearInterval(sectionFiveTimer);
    sectionFiveButtonForward.current.style.opacity = "1";
    sectionFiveButtonForward.current.style.backgroundColor = "#c0aa83";
    sectionFiveButtonForward.current.style.pointerEvents = "all";
    sectionFiveSliderCounter = sectionFiveSliderCounter + 1;
    let sectionFiveSliderTranslateIndex;

    if (window.innerWidth <= 540) {
      sectionFiveSliderTranslateIndex = sectionFiveSliderCounter * 20.3;
    } else if (window.innerWidth <= 750) {
      sectionFiveSliderTranslateIndex = sectionFiveSliderCounter * 30.3;
    } else if (window.innerWidth <= 1060) {
      sectionFiveSliderTranslateIndex = sectionFiveSliderCounter * 43.3;
    } else {
      sectionFiveSliderTranslateIndex = sectionFiveSliderCounter * 63.3;
    }

    sectionFiveSlider.current.style.transform = `translateX(${sectionFiveSliderTranslateIndex}rem)`;
    if (sectionFiveSliderCounter === 0) {
      sectionFiveButtonBack.current.style.opacity = "0.5";
      sectionFiveButtonBack.current.style.backgroundColor = "white";
      sectionFiveButtonBack.current.style.pointerEvents = "none";
    }
  };
  return (
    <div className="section-five-slider-container">
      <div className="section-five-slider">
        <div className="section-five-slider-actual" ref={sectionFiveSlider}>
          {sectionFiveSliderContent.map((item) => {
            return (
              <SectionFiveSliderCard
                key={item.name}
                name={item.name}
                position={item.position}
                text={item.text}
              />
            );
          })}
        </div>
      </div>
      <div className="section-five-slider-buttons-container">
        <button
          ref={sectionFiveButtonBack}
          className="section-five-slider-button-back"
          onClick={handleSectionFiveButtonBack}
        >
          <ArrowBackIosNewIcon sx={{ fontSize: "20px" }} />
        </button>
        <button
          ref={sectionFiveButtonForward}
          className="section-five-slider-button-forward"
          onClick={handleSectionFiveButtonForward}
        >
          <ArrowForwardIosIcon sx={{ fontSize: "20px" }} />
        </button>
      </div>
    </div>
  );
};
